import { render, staticRenderFns } from "./WaterConfig.vue?vue&type=template&id=91546090&scoped=true"
import script from "./WaterConfig.vue?vue&type=script&lang=ts"
export * from "./WaterConfig.vue?vue&type=script&lang=ts"
import style0 from "./WaterConfig.vue?vue&type=style&index=0&id=91546090&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91546090",
  null
  
)

export default component.exports